import React from 'react';

import ConfirmationModal from 'components/Grid/components/ActionCell/ConfirmationModal';

import { FolderNavigationType } from '../types';

const hasDocumentsInTree = (folder: FolderNavigationType): boolean => {
  if (folder.documentsCount > 0) {
    return true;
  }
  return folder.subfolders.some((subfolder) => hasDocumentsInTree(subfolder));
};

interface DeleteFolderModalProps {
  folder: FolderNavigationType;
  open: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
  loading?: boolean;
}

const DeleteFolderModal: React.FC<DeleteFolderModalProps> = ({
  folder,
  open,
  onClose,
  onDelete,
  loading = false,
}): React.ReactElement => {
  const containsDocuments = hasDocumentsInTree(folder);

  const message = containsDocuments
    ? 'Are you sure you want to delete this folder and all subfolders?'
    : 'Are you sure you want to delete this folder?';

  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onDelete}
      type="text-input"
      title="Delete folder"
      message={message}
      confirmButtonLabel="Delete"
      loading={loading}
    />
  );
};

export default DeleteFolderModal;
